async function blobToJson(blob)
{
	try
	{
		let responseText = await new Promise
		(
			(resolve, reject) =>
			{
				let reader = new FileReader()

				reader.addEventListener('abort', reject)
				reader.addEventListener('error', reject)
				reader.addEventListener('loadend', () => resolve(reader.result))
				reader.readAsText(blob)
			}
		)

		return JSON.parse(responseText)
	}
	catch(e)
	{
		return blob
	}
}

export default blobToJson